exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab,.wrapper{margin:auto}.tab{max-width:100%;overflow:hidden;background-color:#fff}.centerfooter{margin:auto;width:100px}div.main{overflow:hidden;display:block;position:relative}footer{bottom:0;display:block;margin:auto}.tab button{background-color:inherit;float:left;border:none;outline:none;cursor:pointer;padding:14px 16px;transition:.3s}.tab button:hover{background-color:#a6ce84}.tab button.active{background-color:#75c4b7}.tabcontent{display:none;padding:6px 12px;border:1px solid #ccc;border-top:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a41c7fa","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 63
// module chunks = 0